import {AppState} from "./reducer";

export const selectUserState = (state: AppState) => state.userState;
export const selectConfigState = (state: AppState) => state.configState;
export const selectCommonState = (state: AppState) => state.commonState;
export const selectMealsState = (state: AppState) => state.mealsState;
export const selectTrainingsState = (state: AppState) => state.trainingsState;
